import { Controller } from '@hotwired/stimulus'

// Codex CCP decision tree (ux-design §2.1). Mirrors the server-side
// `Compliance::CodexDecisionTree`: five yes/no answers → a classification that
// suggests and pre-fills the control point's `kind`. Advisory only — the
// manager can override the select afterwards.
export default class extends Controller {
  static targets = [
    'controlMeasuresExist', 'controlNecessaryForSafety', 'stepEliminatesHazard',
    'contaminationCouldExceedLimit', 'subsequentStepControls', 'result', 'resultLabel'
  ]

  static values = { kindField: String }

  evaluate () {
    const outcome = this.classify()
    this.resultLabelTarget.textContent = this.labelFor(outcome)
    this.resultTarget.hidden = false

    const kind = { ccp: 'ccp', oprp: 'oprp', prp: 'prp' }[outcome]
    if (kind) this.applyKind(kind)
  }

  classify () {
    if (!this.controlMeasuresExistTarget.checked) {
      return this.controlNecessaryForSafetyTarget.checked ? 'modify_needed' : 'prp'
    }
    if (this.stepEliminatesHazardTarget.checked) return 'ccp'
    if (!this.contaminationCouldExceedLimitTarget.checked) return 'prp'
    return this.subsequentStepControlsTarget.checked ? 'oprp' : 'ccp'
  }

  labelFor (outcome) {
    const el = this.element.querySelector(`[data-outcome="${outcome}"]`)
    return el ? el.textContent : outcome
  }

  applyKind (kind) {
    const select = document.getElementById(this.kindFieldValue)
    if (select) select.value = kind
  }
}
